export class DatePickerMessages {
    public static readonly CLEAR_DATE = 'date-picker.clear-date';
}